<template>
  <div class="dashboard-widget-and-image-list tab-wrapper origin">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="위젯" name="widget"></el-tab-pane>
      <el-tab-pane label="관리대상" name="managed"></el-tab-pane>
      <el-tab-pane label="이미지" name="image"></el-tab-pane>
    </el-tabs>
    <keep-alive>
      <component :is="activeTab==='widget' ? WDashboardWidgetList : null" />
      <component :is="activeTab==='managed' ? WManagedObjectList : null" style="height: calc(100% - 60px);"/>
      <component :is="activeTab==='image' ? WCustomImageList : null" ref="customImageList" :draggable="true" style="height: calc(100% - 60px);"/>
      <!-- <w-dashboard-widget-list v-show="activeTab==='widget'"></w-dashboard-widget-list>
      <w-managed-object-list v-show="activeTab==='managed'" style="height: calc(100% - 60px);"></w-managed-object-list>
      <w-custom-image-list ref="customImageList" v-show="activeTab==='image'" :draggable="true" style="height: calc(100% - 60px);"></w-custom-image-list> -->
    </keep-alive>
  </div>
</template>

<script>
import DashboardConst from '@/constants/dashboard';
import WDashboardWidgetList from '@/views/dashboard/components/frame/DashboardWidgetList';
import WCustomImageList from '@/views/dashboard/components/CustomImageList';
import WManagedObjectList from '@/views/dashboard/components/ManagedObjectList';

export default {
  name: 'WDashboardElementList',
  components: {
    WDashboardWidgetList,
    WCustomImageList,
    WManagedObjectList,
  },
  data() {
    return {
      WDashboardWidgetList,
      WCustomImageList,
      WManagedObjectList,
      activeTab: 'widget',
    };
  },
  computed: {
    viewMode() {
      return this.$store.getters.getDashboardViewMode;
    },
  },
  watch: {
    viewMode(newValue) {
      // 편집 모드로 진입하면 기본적으로 위젯 탭을 활성화 시킨다.
      if (newValue === DashboardConst.VIEW_MODE.EDIT) {
        this.activeTab = 'widget';
      }
    },
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="scss">
.dashboard-widget-and-image-list {
  height: 100%;
  width: 100%;
  padding: 0px 20px;

  .dashboard-widget-list {
      padding: 0;
  }

  /* 탭 스타일 시작 */
  .el-tabs__content {
    min-height: 0px;
  }
  .el-tabs__item {
    color: #888;
  }
  .el-tabs__item.is-active,
  .el-tabs__item:active,
  .el-tabs__item:focus,
  .el-tabs__item:hover {
    color: #333;
  }
  .el-tabs__active-bar {
    background-color: #555 !important;
  }
  /* 탭 스타일 끝 */
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/frame/DashboardElementList.vue